import { render } from "./ButtonGridInput.vue?vue&type=template&id=8c3d591e"
import script from "./ButtonGridInput.vue?vue&type=script&lang=js"
export * from "./ButtonGridInput.vue?vue&type=script&lang=js"

import "./ButtonGridInput.vue?vue&type=style&index=0&id=8c3d591e&lang=scss"

import exportComponent from "/Users/Ralph/repos/verduurzamen/quickcheck/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__